import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { Link, NavLink, Outlet, Navigate, useLocation } from "react-router-dom";

const tabs = [
    { label: "Driver Licences", path: "/approvals/driver-licences" },
    { label: "Road Worthiness", path: "/approvals/road-worthiness" },
];

export const ApprovalsLayout = () => {
    const location = useLocation();

    if (location.pathname === "/approvals" || location.pathname === "/approvals/") {
        return <Navigate to="/approvals/driver-licences" replace />;
    }

    const isDetailPage = /^\/approvals\/driver-licences\/[^/]+/.test(location.pathname);

    return (
        <div className="space-y-6">
            {!isDetailPage && (
                <div>
                    <Link
                        to="/"
                        className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200"
                    >
                        <ArrowLeftIcon className="h-4 w-4" />
                        Back to Dashboard
                    </Link>
                    <h1 className="text-2xl font-bold text-slate-900 dark:text-slate-100">
                        <span className="mt-3 block">Approvals</span>
                    </h1>
                    <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
                        Review driver licences and road worthiness.
                    </p>
                    <div className="mt-4 flex gap-1 border-b border-slate-200 dark:border-slate-800">
                        {tabs.map((tab) => (
                            <NavLink
                                key={tab.path}
                                to={tab.path}
                                className={({ isActive }) =>
                                    `relative px-4 py-2.5 text-sm font-medium transition-colors ${
                                        isActive
                                            ? "text-primary-600 dark:text-primary-400"
                                            : "text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-300"
                                    }`
                                }
                            >
                                {({ isActive }) => (
                                    <>
                                        {tab.label}
                                        {isActive && (
                                            <span className="absolute bottom-0 left-0 right-0 h-0.5 rounded-full bg-primary-600 dark:bg-primary-400" />
                                        )}
                                    </>
                                )}
                            </NavLink>
                        ))}
                    </div>
                </div>
            )}
            <Outlet />
        </div>
    );
};
